<div title="Socket connection status">
    <mat-icon [ngClass]="isSynchronized?'synchronized':'not-synchronized'">fiber_manual_record</mat-icon>
</div>